import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-shield-check-line',
    title: 'Commercial Coverage',
    desc: 'General Liability, Workers Comp &amp; BOP. Protect your business from third-party claims, employee injuries, and property damage with essential coverage that fits your budget.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Specialized Solutions',
    desc: 'Coal Mines, Contractors &amp; High-Risk Operations. Custom-tailored policies for industries that need more than the basics — because your work isn\'t ordinary.',
  },
  {
    icon: 'ri-home-heart-line',
    title: 'Personal Lines &amp; Life',
    desc: 'Home, Auto, Life Insurance &amp; more. We protect what matters most — your family, your home, and your future — with personalized coverage across all 5 states we serve.',
  },
];

export default function ServicesPreview() {
  return (
    <section className="py-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-14">
          <span className="text-[#D4AF37] text-xs font-bold uppercase tracking-[0.3em] font-sans">What We Offer</span>
          <h2 className="font-serif text-5xl md:text-6xl text-white mt-3 uppercase">Our Services</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((svc, i) => (
            <div key={i} className="bg-[#111111] border border-[#D4AF37]/15 rounded-md p-8 hover:border-[#D4AF37]/50 transition-colors duration-300 group">
              <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-md mb-6">
                <i className={`${svc.icon} text-[#D4AF37] text-2xl`} />
              </div>
              <h3 className="font-serif text-xl text-[#D4AF37] font-bold mb-3 uppercase">{svc.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-6 font-sans" dangerouslySetInnerHTML={{ __html: svc.desc }} />
              <Link to="/services"
                className="inline-flex items-center gap-2 text-white/60 text-xs font-bold uppercase tracking-widest hover:text-[#D4AF37] transition-colors cursor-pointer font-sans group-hover:text-[#D4AF37]">
                Learn More <i className="ri-arrow-right-line" />
              </Link>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link to="/services"
            className="inline-block px-8 py-4 border border-[#D4AF37] text-[#D4AF37] text-xs font-bold uppercase tracking-widest rounded-md hover:bg-[#D4AF37] hover:text-black transition-all duration-200 whitespace-nowrap cursor-pointer font-sans">
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
}
